module.exports = __webpack_public_path__ + "static/key-donutsjustice-4be0f660a8fee64a513445341568890f.webp";